// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__hYvsq","rightAdornment":"Header_rightAdornment__g8cCp"};